export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const STATE_INITIALIZED = "STATE_INITIALIZED";
export const UPDATE_PREFERENCES_SUCCESS = "UPDATE_PREFERENCES_SUCCESS";
